import { flattenPublicPromise } from '@/util/index';
import { getSearchGoodList } from '@/api/newApi/search';
import { reportSearchResultCounts } from '@/dataPort/searchResultReport';
import { getCartNum, syncCartNumCache } from '@/api/newApi/carts';
import { message } from 'antd';
import { SEARCH_LIST_PAGE_SIZE } from '@/constants/searchList';
import { beginSearchListRequest, isActiveSearchListRequest } from '@/util/searchListRequest';
import { sanitizeSearchParamsWithRuntimePermissions } from '@/util/searchListPermission';
export const dispatchAll = (checket: boolean) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_ALL', isChecked: checket });
  };
};

//用户信息
export const dispatchUser = (data: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_USER_DATA', data });
  };
};
//地址信息
export const dispatchLocation = (data: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_LOCATION_DATA', data });
  };
};
// 顶部选中地址
export const dispatchSelectedAddress = (data: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_SELECTED_ADDRESS', data });
  };
};
// 顶部邮编查询得到的配送位置，与下单所需的收货地址 ID 分开保存。
export const dispatchSelectedPostalLocation = (data: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_SELECTED_POSTAL_LOCATION', data });
  };
};
//客服地址
export const dispatchCustomer = (url: string) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_CUSTOMER', url });
  };
};
//请求采购清单数量
export const dispatchShopCar = () => {
  return async (dispatch: Function) => {
    try {
      const shopCarNum: any = await getCartNum({}, false);
      if (shopCarNum?.success) {
        dispatch(dispatchShopCarNum(shopCarNum.value ? shopCarNum.value : 0));
      }
    } catch (error) {
      // 购物车角标刷新失败不应让已成功的加购流程产生未处理拒绝或清零。
      console.error('获取购物车数量失败:', error);
    }
  };
};

//不用请求接口，改变采购清单数量
export const dispatchShopCarNum = (num: any) => {
  return async (dispatch: Function) => {
    syncCartNumCache(num);
    dispatch({ type: 'UPDATE_SHOP_CAR', num: num });
  };
};
//用户菜单
export const dispatchInitMenus = (data: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_USER_INIT_MENUS', data });
  };
};
// 用户权限map
export const dispatchPublicPromise = (data: any) => {
  const value = data?.value;
  const fpp = flattenPublicPromise(value);

  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_USER_PUBLIC_PROMISE', fpp });
  };
};
// 当前登录用户使用权限类型
export const dispatchPromiseWhite = (data: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_USER_PROMISE_WHITE', data });
  };
};
// search list
export const dispatchAnnounceData = (
  params: any,
  isFirst: boolean,
  selectParams?: any,
  reportOptions?: { reuseReportData?: boolean; forcedReportId?: string },
) => {
  return async (dispatch: Function, getState: any) => {
    const requestParams = sanitizeSearchParamsWithRuntimePermissions(params);
    const storedParams = sanitizeSearchParamsWithRuntimePermissions(params);
    delete storedParams.refreshFirstTwoPagesCache;
    const prevSearchListState = getState()?.SearchList || {};
    // 未显式传入 selectParams 时保留上次状态，避免价格等筛选把品牌/扩展属性选中态冲掉
    const mergedSelectParams =
      selectParams !== undefined ? selectParams : prevSearchListState.selectParams;
    const requestId = beginSearchListRequest();
    dispatch({
      type: 'SEARCH_LIST_LOADING_START',
      params: storedParams,
      selectParams: mergedSelectParams,
    });

    const currentParams = prevSearchListState.params || {};
    const userPin = getState()?.User?.data?.[0]?.pin || '';

    try {
      const res: any = await getSearchGoodList({
        ...requestParams,
      });

      if (!isActiveSearchListRequest(requestId)) {
        return;
      }

      if (res?.success) {
        dispatch({
          type: 'UPDATE_GOODSLIST',
          pageInfo: res.value && res.value.page,
          data: res.value ? (res.value.wares == null ? [] : res.value.wares) : [],
          brandList: Array.isArray(res.value?.brandList) ? res.value.brandList : [],
          priceRangeList: [],
          extAttrList: [],
          promiseLabels: Array.isArray(res.value?.promiseLabels) ? res.value.promiseLabels : [],
          toolNum: res?.value?.page?.maxResultCount || 0,
          page: storedParams.pageNo ? storedParams.pageNo : 1,
          pageSize: storedParams.pageSize ? storedParams.pageSize : SEARCH_LIST_PAGE_SIZE,
          params: storedParams,
          selectParams: mergedSelectParams,
          isCache: !isFirst,
        });
        reportSearchResultCounts({
          params: storedParams,
          currentParams,
          response: res,
          pin: userPin,
          reuseReportData: reportOptions?.reuseReportData,
          forcedReportId: reportOptions?.forcedReportId,
        });
      } else {
        dispatch({
          type: 'SEARCH_LIST_FETCH_ERROR',
          message: res?.message,
          params: storedParams,
          selectParams: mergedSelectParams,
        });
      }
    } catch (error) {
      if (!isActiveSearchListRequest(requestId)) {
        return;
      }
      dispatch({
        type: 'SEARCH_LIST_FETCH_ERROR',
        params: storedParams,
        selectParams: mergedSelectParams,
      });
      console.error('search list request failed', error);
    }
  };
};

export const retrySearchList = () => {
  return (dispatch: Function, getState: any) => {
    const { lastFetchParams, lastFetchSelectParams } = getState()?.SearchList || {};
    if (!lastFetchParams) {
      return;
    }
    return dispatch(dispatchAnnounceData(lastFetchParams, false, lastFetchSelectParams));
  };
};
export const dispatchOneChecked = (checket: boolean, id: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_ONE', isChecked: checket, id: id });
  };
};

export const dispatchOneNum = (num: any, id: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_NUM', num: num, id: id });
  };
};
export const dispatchViewType = (viewType: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_VIEW', viewType });
  };
};
export const dispatchCheckCount = (count: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_CHECKCOUNT', count });
  };
};
export const dispatchAllCheckContrast = (contrastList: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_ALLCHECKCONTRAST', contrastList });
  };
};
export const dispatchCheckContrast = (checked: any, id: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_CHECKCONTRAST', isChecked: checked, id: id });
  };
};
//商详，选中服务
export const dispatchCheckService = (checkedService: any) => {
  return async (dispatch: Function, getState: any) => {
    dispatch({ type: 'UPDATE_CHECKEDSERVICE', checkedService: checkedService });
  };
};

// 搜索内容
export const setSearchContent = (text: string) => {
  return async (dispatch: Function) => {
    text && dispatch({ type: 'UPDATE_QUERY_NAME', queryName: text });
  };
};

/***********审批流相关**********/

export const dispatchApprovalData = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_APPROVAL_DATA', data });
  };
};

export const dispatchApprovalDeleteModel = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_SHOW_DELETE_MODAL', data });
  };
};
export const dispatchApprovalModifyNameModel = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_SHOW_MODIFY_NAME_MODAL', data });
  };
};
//
export const dispatchApprovalAccountModel = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_SHOW_ADD_ACCOUNT_DRAWER', data });
  };
};

export const dispatchApprovalConditionDrawer = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_SHOW_CONDITION_DRAWER', data });
  };
};

export const dispatchApprovalType = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_APPROVAL_TYPE', data });
  };
};

export const dispatchApprovalName = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_APPROVAL_NAME', data });
  };
};

// 修改审查员
export const dispatchApprovalExaminePins = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_APPROVAL_EXAMINE_PINS', data });
  };
};

// 修改节点
export const dispatchApprovalNodes = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_APPROVAL_NODES', data });
  };
};
// 修改错误ID
export const dispatchApprovalErrorNodeId = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_ERROR_NODE_ID', data });
  };
};

// 修改无条件第二个节点ID
export const dispatchSecondNoConditionId = (data: any) => {
  // 定义一个异步的高阶函数，用于分发action
  return async (dispatch: Function) => {
    // 调用dispatch函数，分发一个带有type和data的action对象
    dispatch({ type: 'UPDATE_SECOND_NO_CONDITION_ID', data });
  };
};

// 更新客户权限
export const dispatchUserLimit = (data: any) => {
  return async (dispatch: Function) => {
    dispatch({ type: 'UPDATE_USER_LIMIT', data });
  };
};
